import React, { FunctionComponent } from "react";
import styles from "./VideoShortText.module.scss";
import VideoShortTextProps from "./VideoShortText.interface";

import combineClasses from "helpers/combine-classes";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import formatDynamicTextBreak from "blocks/helpers/formatDynamicTextBreak";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import formatDynamicTextColor from "blocks/helpers/formatDynamicTextColor";
import { YouTubeEmbed } from "react-social-media-embed";
import VideoViewer from "components/VideoViewer/VideoViewer";

const VideoShortText: FunctionComponent<VideoShortTextProps> = (props) => {
    const wrapperStyles = getWrapperStyles(props.settings);
    const processedHeadline = getProcessedRichtext(formatDynamicTextBreak(formatDynamicTextColor(props.content.headline)));
    const processedBodyText = getProcessedRichtext(props.content.bodyText);

    const isLoop = props.content.loop ? props.content.loop : false;
    const isAutoplay = props.content.autoplay ? props.content.autoplay : false;

    return (
        <section className={combineClasses([styles.wrapper, ...wrapperStyles])}>
            <div className={styles.container}>
                {/* Media */}

                {/* Content */}
                <div className={styles.content}>
                    <div className={styles.inner}>
                        {props.content.youtubeURL && !props.content.media ? (
                            <div className={styles.iframe_container}>
                                <div className={styles.iframe_container_2}>
                                    <YouTubeEmbed url={props.content.youtubeURL?.toString() || ""} />
                                </div>
                            </div>
                        ) : null}

                        {/* Media */}
                        <div className={styles.media}>
                            {props.content.media ? (
                                <div className={styles.video_wrapper}>
                                    <VideoViewer
                                        key={props.content.media._id}
                                        src={props.content.media?.url || ""}
                                        heightRatio={690 / 1280}
                                        loop={isLoop}
                                        soundButton={false}
                                        className={styles.video}
                                        autoplay={isAutoplay}
                                        isRounded={true}
                                    />
                                </div>
                            ) : null}
                        </div>

                        <div className={styles.text_content}>
                            <DynamicHeading
                                className={styles.headline}
                                headlineSize={props.content.headlineSize}
                                headlineWeight={props.content.headlineWeight}
                                innerHtml={processedHeadline}
                            ></DynamicHeading>

                            {processedBodyText ? (
                                <div
                                    className={styles.bodyText}
                                    dangerouslySetInnerHTML={processedBodyText}
                                ></div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VideoShortText;
